import * as types from './actionTypes';

const initialState = {
  modes: [],
  projects: [],
  modules: [],
  tasks: [],
  taskTypes: [],
  timesheetList: [],
  monthDetails: [],
  clientList:[],
  loading: false,
  error: null,
  success: false,
};

const timesheetReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_TIMESHEET_MODE_REQUEST:
    case types.FETCH_TIMESHEET_PROJECT_REQUEST:
    case types.FETCH_TIMESHEET_MODULE_REQUEST:
    case types.FETCH_TIMESHEET_TASK_REQUEST:
    case types.FETCH_TIMESHEET_TASKTYPE_REQUEST:
    case types.FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_REQUEST:
    case types.FETCH_TIMESHEET_LIST_REQUEST:
    case types.FETCH_TIMESHEET_MONTH_DETAILS_REQUEST:
    case types.SAVE_TIMESHEET_DETAILS_REQUEST:
    case types.CHANGE_TIMESHEET_TASK_STATUS_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_TIMESHEET_MODE_SUCCESS:
      return { ...state, loading: false, modes: action.payload, success: false };

    case types.FETCH_TIMESHEET_PROJECT_SUCCESS:
      return { ...state, loading: false, projects: action.payload, success: false };

    case types.FETCH_TIMESHEET_MODULE_SUCCESS:
      return { ...state, loading: false, modules: action.payload, success: false };

    case types.FETCH_TIMESHEET_TASK_SUCCESS:
      return { ...state, loading: false, tasks: action.payload, success: false };

    case types.FETCH_TIMESHEET_TASKTYPE_SUCCESS:
      return { ...state, loading: false, taskTypes: action.payload, success: false };

    case types.FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_SUCCESS:
      return { ...state, loading: false, taskTypes: action.payload, success: false };

    case types.FETCH_TIMESHEET_LIST_SUCCESS:
      return { ...state, loading: false, timesheetList: action.payload , success: false};

    case types.FETCH_TIMESHEET_MONTH_DETAILS_SUCCESS:
      return { ...state, loading: false, monthDetails: action.payload, success: false };

    case types.SAVE_TIMESHEET_DETAILS_SUCCESS:
    case types.CHANGE_TIMESHEET_TASK_STATUS_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.FETCH_TIMESHEET_MODE_FAILURE:
    case types.FETCH_TIMESHEET_PROJECT_FAILURE:
    case types.FETCH_TIMESHEET_MODULE_FAILURE:
    case types.FETCH_TIMESHEET_TASK_FAILURE:
    case types.FETCH_TIMESHEET_NON_PROJECT_TASKTYPE_FAILURE:
      case types.FETCH_TIMESHEET_TASKTYPE_FAILURE:
    case types.FETCH_TIMESHEET_LIST_FAILURE:
    case types.FETCH_TIMESHEET_MONTH_DETAILS_FAILURE:
    case types.SAVE_TIMESHEET_DETAILS_FAILURE:
    case types.CHANGE_TIMESHEET_TASK_STATUS_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case types.FETCH_TIMESHEET_CLIENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.FETCH_TIMESHEET_CLIENT_SUCCESS:
      return {
        ...state,
        loading: false,
        clientList: action.payload,
        success: false,
      };

    case types.FETCH_TIMESHEET_CLIENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    default:
      return state;
  }
};

export default timesheetReducer;
